export const domesticRoundtrip = {
    FlightType: "Domestic",
    Errors: null,
    ResponseData: {
        SessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
        TotalCount: 17,
        ResultList: [
            {
                TotalCount: 8,
                ResultList: [
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-28T08:00:00",
                                DepartureAirportCode: "NBO",
                                DepartureAirportName: "Jomo Kenyatta International Airport",
                                DepartureAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                ArrivalDate: "2024-01-28T09:00:00",
                                ArrivalAirportCode: "MBA",
                                ArrivalAirportName: "Moi International Airport",
                                ArrivalAirportFullName: "Moi International Airport (MBA)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG2",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1",
                                        DepartureTerminalName: "1D",
                                        DepartureDate: "2024-01-28T08:00:00",
                                        DepartureAirportCode: "NBO",
                                        DepartureAirportName: "Jomo Kenyatta International Airport",
                                        DepartureAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        ArrivalDate: "2024-01-28T09:00:00",
                                        ArrivalAirportCode: "MBA",
                                        ArrivalAirportName: "Moi International Airport",
                                        ArrivalAirportFullName: "Moi International Airport (MBA)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "24",
                                        BaggageUnit: "kg",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 4705.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9685.0,
                        Taxes: 4980.0,
                        GdsFees: 0.0,
                        TotalFare: 10330.0,
                        OriginalTotalFare: 10330.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4980.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4705.0,
                                TotalFare: 10330.0,
                                GdsTotalFare: 9685.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4705.0,
                                OriginalGdsTotalFare: 9685.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10330.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 1,
                            RecommendationID: 10,
                            OWNER: "KQ",
                            OFFER_ID: "SP1F-7527725011247533395-1",
                            FLIGHT_KEY: "KQ-FLT1",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "7df2fa8182be430db09888a37b3d1bf2",
                            GdsCombinationID: 10,
                            GdsRecommendationID: 8,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 0,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "AA",
                                OperatingAirlineName: "American Airlines",
                                MarketingAirlineCode: "AA",
                                MarketingAirlineName: "American Airlines",
                                Duration: "6h:45m",
                                StopOvers: 2,
                                DepartureDate: "2024-01-20T12:30:00",
                                DepartureAirportCode: "DFW",
                                DepartureAirportName: "Dallas/Fort Worth International Airport",
                                DepartureAirportFullName: "Dallas/Fort Worth International Airport (DFW)",
                                ArrivalDate: "2024-01-20T19:15:00",
                                ArrivalAirportCode: "LGA",
                                ArrivalAirportName: "LaGuardia Airport",
                                ArrivalAirportFullName: "LaGuardia Airport (LGA)",
                                TicketFare: 180000.0,
                                ServiceCharge: 12000.0,
                                TotalFare: 192000.0,
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG4",
                                        Aircraft: "E90",
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "American Airlines",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "American Airlines",
                                        ArrivalTerminalName: "1",
                                        DepartureTerminalName: "1D",
                                        DepartureDate: "2024-01-28T13:00:00",
                                        DepartureAirportCode: "DFW",
                                        DepartureAirportName: "Dallas/Fort Worth International Airport",
                                        DepartureAirportFullName: "Dallas/Fort Worth International Airport (DFW)",
                                        ArrivalDate: "2024-01-28T14:00:00",
                                        ArrivalAirportCode: "LGA",
                                        ArrivalAirportName: "LaGuardia Airport",
                                        ArrivalAirportFullName: "LaGuardia Airport (LGA)",
                                        FlightDuration: "6h:45m",
                                        HasStopOver: true,
                                        StopOverDuartion: "3h:15m",
                                        TotalDuration: "6h:45m",
                                        FlightClass: "Economy",
                                        Baggages: "24",
                                        BaggageUnit: "kg",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 4705.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9685.0,
                        Taxes: 4980.0,
                        GdsFees: 0.0,
                        TotalFare: 10330.0,
                        OriginalTotalFare: 10330.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4980.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4705.0,
                                TotalFare: 10330.0,
                                GdsTotalFare: 9685.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4705.0,
                                OriginalGdsTotalFare: 9685.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10330.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 1,
                            RecommendationID: 15,
                            OWNER: "KQ",
                            OFFER_ID: "SP1F-7527725011247533395-2",
                            FLIGHT_KEY: "KQ-FLT2",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "7df2fa8182be430db09888a37b3d1bf2",
                            GdsCombinationID: 22,
                            GdsRecommendationID: 8,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 0,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "LH",
                                OperatingAirlineName: "Lufthansa",
                                MarketingAirlineCode: "LH",
                                MarketingAirlineName: "Lufthansa",
                                Duration: "1h:30m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-20T10:45:00",
                                DepartureAirportCode: "FRA",
                                DepartureAirportName: "Frankfurt Airport",
                                DepartureAirportFullName: "Frankfurt Airport (FRA)",
                                ArrivalDate: "2024-01-20T12:15:00",
                                ArrivalAirportCode: "CDG",
                                ArrivalAirportName: "Charles de Gaulle Airport",
                                ArrivalAirportFullName: "Charles de Gaulle Airport (CDG)",
                                TicketFare: 110000.0,
                                ServiceCharge: 10000.0,
                                TotalFare: 120000.0,

                                FlightEntries: [
                                    {
                                        OperatingAirlineCode: "LH",
                                        OperatingAirlineName: "Lufthansa",
                                        MarketingAirlineCode: "LH",
                                        MarketingAirlineName: "Lufthansa",
                                        Duration: "1h:30m",
                                        StopOvers: 0,
                                        HasStopOver: false,
                                        DepartureDate: "2024-01-20T10:45:00",
                                        DepartureAirportCode: "FRA",
                                        DepartureAirportName: "Frankfurt Airport",
                                        DepartureAirportFullName: "Frankfurt Airport (FRA)",
                                        ArrivalDate: "2024-01-20T12:15:00",
                                        ArrivalAirportCode: "CDG",
                                        ArrivalAirportName: "Charles de Gaulle Airport",
                                        ArrivalAirportFullName: "Charles de Gaulle Airport (CDG)",
                                        FlightNumber: "KQ-SEG5",
                                        Aircraft: null,
                                        ArrivalTerminalName: "1",
                                        DepartureTerminalName: "1D",
                                        FlightDuration: "1h:30m",
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "24",
                                        BaggageUnit: "kg",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 4705.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9685.0,
                        Taxes: 4980.0,
                        GdsFees: 0.0,
                        TotalFare: 10330.0,
                        OriginalTotalFare: 10330.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4980.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4705.0,
                                TotalFare: 10330.0,
                                GdsTotalFare: 9685.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4705.0,
                                OriginalGdsTotalFare: 9685.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10330.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 1,
                            RecommendationID: 11,
                            OWNER: "KQ",
                            OFFER_ID: "SP1F-7527725011247533395-3",
                            FLIGHT_KEY: "KQ-FLT3",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "7df2fa8182be430db09888a37b3d1bf2",
                            GdsCombinationID: 11,
                            GdsRecommendationID: 8,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 0,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "SQ",
                                OperatingAirlineName: "Singapore Airlines",
                                MarketingAirlineCode: "SQ",
                                MarketingAirlineName: "Singapore Airlines",
                                Duration: "7h:30m",
                                StopOvers: 1,
                                DepartureDate: "2024-01-20T08:00:00",
                                DepartureAirportCode: "SIN",
                                DepartureAirportName: "Changi Airport",
                                DepartureAirportFullName: "Changi Airport (SIN)",
                                ArrivalDate: "2024-01-20T19:30:00",
                                ArrivalAirportCode: "LAX",
                                ArrivalAirportName: "Los Angeles International Airport",
                                ArrivalAirportFullName: "Los Angeles International Airport (LAX)",

                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG6",
                                        Aircraft: null,
                                        OperatingAirlineCode: "SQ",
                                        OperatingAirlineName: "Singapore Airlines",
                                        MarketingAirlineCode: "SQ",
                                        MarketingAirlineName: "Singapore Airlines",
                                        ArrivalTerminalName: "1",
                                        DepartureTerminalName: "1D",
                                        DepartureDate: "2024-01-20T08:00:00",
                                        DepartureAirportCode: "SIN",
                                        DepartureAirportName: "Changi Airport",
                                        DepartureAirportFullName: "Changi Airport (SIN)",
                                        ArrivalDate: "2024-01-20T19:30:00",
                                        ArrivalAirportCode: "LAX",
                                        ArrivalAirportName: "Los Angeles International Airport",
                                        ArrivalAirportFullName: "Los Angeles International Airport (LAX)",
                                        FlightDuration: "7h:30m",
                                        HasStopOver: true,
                                        StopOverDuartion: "4h:00m",
                                        TotalDuration: "7h:30m",
                                        FlightClass: "Business",
                                        Baggages: "24",
                                        BaggageUnit: "kg",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 4705.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9685.0,
                        Taxes: 4980.0,
                        GdsFees: 0.0,
                        TotalFare: 120000.0,
                        OriginalTotalFare: 130000.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4980.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4705.0,
                                TotalFare: 10330.0,
                                GdsTotalFare: 9685.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4705.0,
                                OriginalGdsTotalFare: 9685.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10330.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 1,
                            RecommendationID: 13,
                            OWNER: "KQ",
                            OFFER_ID: "SP1F-7527725011247533395-4",
                            FLIGHT_KEY: "KQ-FLT4",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "7df2fa8182be430db09888a37b3d1bf2",
                            GdsCombinationID: 15,
                            GdsRecommendationID: 8,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 0,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "EK",
                                OperatingAirlineName: "Emirates",
                                MarketingAirlineCode: "EK",
                                MarketingAirlineName: "Emirates",
                                Duration: "4h:00m",
                                StopOvers: 1,

                                DepartureDate: "2024-01-20T14:00:00",
                                DepartureAirportCode: "DXB",
                                DepartureAirportName: "Dubai International Airport",
                                DepartureAirportFullName: "Dubai International Airport (DXB)",
                                ArrivalDate: "2024-01-20T18:00:00",
                                ArrivalAirportCode: "JFK",
                                ArrivalAirportName: "John F. Kennedy International Airport",
                                ArrivalAirportFullName: "John F. Kennedy International Airport (JFK)",

                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG7",
                                        Aircraft: null,

                                        OperatingAirlineCode: "EK",
                                        OperatingAirlineName: "Emirates",
                                        MarketingAirlineCode: "EK",
                                        MarketingAirlineName: "Emirates",
                                        ArrivalTerminalName: "1",
                                        DepartureTerminalName: "1D",
                                        DepartureDate: "2024-01-20T14:00:00",
                                        DepartureAirportCode: "DXB",
                                        DepartureAirportName: "Dubai International Airport",
                                        DepartureAirportFullName: "Dubai International Airport (DXB)",
                                        ArrivalDate: "2024-01-20T18:00:00",
                                        ArrivalAirportCode: "JFK",
                                        ArrivalAirportName: "John F. Kennedy International Airport",
                                        ArrivalAirportFullName: "John F. Kennedy International Airport (JFK)",
                                        FlightDuration: "4h:00m",
                                        HasStopOver: true,
                                        StopOverDuartion: "2h:00m",
                                        FlightClass: "First",
                                        TotalDuration: "1h:00m",

                                        Baggages: "24",
                                        BaggageUnit: "kg",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 4705.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9685.0,
                        Taxes: 4980.0,
                        GdsFees: 0.0,
                        TotalFare: 335000.0,
                        OriginalTotalFare: 335000.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4980.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4705.0,
                                TotalFare: 10330.0,
                                GdsTotalFare: 9685.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4705.0,
                                OriginalGdsTotalFare: 9685.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10330.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 1,
                            RecommendationID: 9,
                            OWNER: "KQ",
                            OFFER_ID: "SP1F-7527725011247533395-5",
                            FLIGHT_KEY: "KQ-FLT5",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "7df2fa8182be430db09888a37b3d1bf2",
                            GdsCombinationID: 9,
                            GdsRecommendationID: 8,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 0,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-28T20:45:00",
                                DepartureAirportCode: "NBO",
                                DepartureAirportName: "Jomo Kenyatta International Airport",
                                DepartureAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                ArrivalDate: "2024-01-28T21:45:00",
                                ArrivalAirportCode: "MBA",
                                ArrivalAirportName: "Moi International Airport",
                                ArrivalAirportFullName: "Moi International Airport (MBA)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG8",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1",
                                        DepartureTerminalName: "1D",
                                        DepartureDate: "2024-01-28T20:45:00",
                                        DepartureAirportCode: "NBO",
                                        DepartureAirportName: "Jomo Kenyatta International Airport",
                                        DepartureAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        ArrivalDate: "2024-01-28T21:45:00",
                                        ArrivalAirportCode: "MBA",
                                        ArrivalAirportName: "Moi International Airport",
                                        ArrivalAirportFullName: "Moi International Airport (MBA)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "24",
                                        BaggageUnit: "kg",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 4705.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9685.0,
                        Taxes: 4980.0,
                        GdsFees: 0.0,
                        TotalFare: 10330.0,
                        OriginalTotalFare: 10330.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4980.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4705.0,
                                TotalFare: 10330.0,
                                GdsTotalFare: 9685.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4705.0,
                                OriginalGdsTotalFare: 9685.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10330.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 1,
                            RecommendationID: 14,
                            OWNER: "KQ",
                            OFFER_ID: "SP1F-7527725011247533395-6",
                            FLIGHT_KEY: "KQ-FLT6",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "7df2fa8182be430db09888a37b3d1bf2",
                            GdsCombinationID: 16,
                            GdsRecommendationID: 8,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 0,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-28T23:59:00",
                                DepartureAirportCode: "NBO",
                                DepartureAirportName: "Jomo Kenyatta International Airport",
                                DepartureAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                ArrivalDate: "2024-01-29T00:59:00",
                                ArrivalAirportCode: "MBA",
                                ArrivalAirportName: "Moi International Airport",
                                ArrivalAirportFullName: "Moi International Airport (MBA)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG9",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1",
                                        DepartureTerminalName: "1D",
                                        DepartureDate: "2024-01-28T23:59:00",
                                        DepartureAirportCode: "NBO",
                                        DepartureAirportName: "Jomo Kenyatta International Airport",
                                        DepartureAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        ArrivalDate: "2024-01-29T00:59:00",
                                        ArrivalAirportCode: "MBA",
                                        ArrivalAirportName: "Moi International Airport",
                                        ArrivalAirportFullName: "Moi International Airport (MBA)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "24",
                                        BaggageUnit: "kg",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 4705.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9685.0,
                        Taxes: 4980.0,
                        GdsFees: 0.0,
                        TotalFare: 10330.0,
                        OriginalTotalFare: 10330.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4980.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4705.0,
                                TotalFare: 10330.0,
                                GdsTotalFare: 9685.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4705.0,
                                OriginalGdsTotalFare: 9685.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10330.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 1,
                            RecommendationID: 12,
                            OWNER: "KQ",
                            OFFER_ID: "SP1F-7527725011247533395-7",
                            FLIGHT_KEY: "KQ-FLT7",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "7df2fa8182be430db09888a37b3d1bf2",
                            GdsCombinationID: 11,
                            GdsRecommendationID: 8,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 0,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-28T10:20:00",
                                DepartureAirportCode: "NBO",
                                DepartureAirportName: "Jomo Kenyatta International Airport",
                                DepartureAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                ArrivalDate: "2024-01-28T11:20:00",
                                ArrivalAirportCode: "MBA",
                                ArrivalAirportName: "Moi International Airport",
                                ArrivalAirportFullName: "Moi International Airport (MBA)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG3",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1",
                                        DepartureTerminalName: "1D",
                                        DepartureDate: "2024-01-28T10:20:00",
                                        DepartureAirportCode: "NBO",
                                        DepartureAirportName: "Jomo Kenyatta International Airport",
                                        DepartureAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        ArrivalDate: "2024-01-28T11:20:00",
                                        ArrivalAirportCode: "MBA",
                                        ArrivalAirportName: "Moi International Airport",
                                        ArrivalAirportFullName: "Moi International Airport (MBA)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "24",
                                        BaggageUnit: "kg",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 9240.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 14220.0,
                        Taxes: 4980.0,
                        GdsFees: 0.0,
                        TotalFare: 14865.0,
                        OriginalTotalFare: 14865.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4980.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 9240.0,
                                TotalFare: 14865.0,
                                GdsTotalFare: 14220.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 9240.0,
                                OriginalGdsTotalFare: 14220.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 14865.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 1,
                            RecommendationID: 16,
                            OWNER: "KQ",
                            OFFER_ID: "SP1F-7527725011247533395-8",
                            FLIGHT_KEY: "KQ-FLT8",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "7df2fa8182be430db09888a37b3d1bf2",
                            GdsCombinationID: 8,
                            GdsRecommendationID: 8,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 0,
                    },
                ],
                Errors: null,
            },
            {
                TotalCount: 9,
                ResultList: [
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-30T04:20:00",
                                DepartureAirportCode: "MBA",
                                DepartureAirportName: "Moi International Airport",
                                DepartureAirportFullName: "Moi International Airport (MBA)",
                                ArrivalDate: "2024-01-30T05:20:00",
                                ArrivalAirportCode: "NBO",
                                ArrivalAirportName: "Jomo Kenyatta International Airport",
                                ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG2",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1D",
                                        DepartureTerminalName: "1",
                                        DepartureDate: "2024-01-30T04:20:00",
                                        DepartureAirportCode: "MBA",
                                        DepartureAirportName: "Moi International Airport",
                                        DepartureAirportFullName: "Moi International Airport (MBA)",
                                        ArrivalDate: "2024-01-30T05:20:00",
                                        ArrivalAirportCode: "NBO",
                                        ArrivalAirportName: "Jomo Kenyatta International Airport",
                                        ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "0",
                                        BaggageUnit: "",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 5960.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9880.0,
                        Taxes: 4920.0,
                        GdsFees: 0.0,
                        TotalFare: 10525.0,
                        OriginalTotalFare: 10525.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4920.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4960.0,
                                TotalFare: 10525.0,
                                GdsTotalFare: 9880.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4960.0,
                                OriginalGdsTotalFare: 9880.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10525.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 0,
                            RecommendationID: 4,
                            OWNER: "KQ",
                            OFFER_ID: "SP2F-17828000861282643849-1",
                            FLIGHT_KEY: "KQ-FLT1",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "2b324018d21f408d99e514c34a7a14e3",
                            GdsCombinationID: 13,
                            GdsRecommendationID: 9,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 1,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-30T08:15:00",
                                DepartureAirportCode: "MBA",
                                DepartureAirportName: "Moi International Airport",
                                DepartureAirportFullName: "Moi International Airport (MBA)",
                                ArrivalDate: "2024-01-30T09:15:00",
                                ArrivalAirportCode: "NBO",
                                ArrivalAirportName: "Jomo Kenyatta International Airport",
                                ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG3",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1D",
                                        DepartureTerminalName: "1",
                                        DepartureDate: "2024-01-30T08:15:00",
                                        DepartureAirportCode: "MBA",
                                        DepartureAirportName: "Moi International Airport",
                                        DepartureAirportFullName: "Moi International Airport (MBA)",
                                        ArrivalDate: "2024-01-30T09:15:00",
                                        ArrivalAirportCode: "NBO",
                                        ArrivalAirportName: "Jomo Kenyatta International Airport",
                                        ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "0",
                                        BaggageUnit: "",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 6960.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9880.0,
                        Taxes: 4920.0,
                        GdsFees: 0.0,
                        TotalFare: 10525.0,
                        OriginalTotalFare: 10525.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4920.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4960.0,
                                TotalFare: 10525.0,
                                GdsTotalFare: 9880.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4960.0,
                                OriginalGdsTotalFare: 9880.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10525.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 0,
                            RecommendationID: 1,
                            OWNER: "KQ",
                            OFFER_ID: "SP2F-17828000861282643849-2",
                            FLIGHT_KEY: "KQ-FLT2",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "2b324018d21f408d99e514c34a7a14e3",
                            GdsCombinationID: 9,
                            GdsRecommendationID: 9,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 1,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-30T09:50:00",
                                DepartureAirportCode: "MBA",
                                DepartureAirportName: "Moi International Airport",
                                DepartureAirportFullName: "Moi International Airport (MBA)",
                                ArrivalDate: "2024-01-30T10:50:00",
                                ArrivalAirportCode: "NBO",
                                ArrivalAirportName: "Jomo Kenyatta International Airport",
                                ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG4",
                                        Aircraft: "73H",
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1D",
                                        DepartureTerminalName: "1",
                                        DepartureDate: "2024-01-30T09:50:00",
                                        DepartureAirportCode: "MBA",
                                        DepartureAirportName: "Moi International Airport",
                                        DepartureAirportFullName: "Moi International Airport (MBA)",
                                        ArrivalDate: "2024-01-30T10:50:00",
                                        ArrivalAirportCode: "NBO",
                                        ArrivalAirportName: "Jomo Kenyatta International Airport",
                                        ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "0",
                                        BaggageUnit: "",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 7960.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9880.0,
                        Taxes: 4920.0,
                        GdsFees: 0.0,
                        TotalFare: 10525.0,
                        OriginalTotalFare: 10525.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4920.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4960.0,
                                TotalFare: 10525.0,
                                GdsTotalFare: 9880.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4960.0,
                                OriginalGdsTotalFare: 9880.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10525.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 0,
                            RecommendationID: 0,
                            OWNER: "KQ",
                            OFFER_ID: "SP2F-17828000861282643849-3",
                            FLIGHT_KEY: "KQ-FLT3",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "2b324018d21f408d99e514c34a7a14e3",
                            GdsCombinationID: 9,
                            GdsRecommendationID: 9,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 1,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-30T13:20:00",
                                DepartureAirportCode: "MBA",
                                DepartureAirportName: "Moi International Airport",
                                DepartureAirportFullName: "Moi International Airport (MBA)",
                                ArrivalDate: "2024-01-30T14:20:00",
                                ArrivalAirportCode: "NBO",
                                ArrivalAirportName: "Jomo Kenyatta International Airport",
                                ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG6",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1D",
                                        DepartureTerminalName: "1",
                                        DepartureDate: "2024-01-30T13:20:00",
                                        DepartureAirportCode: "MBA",
                                        DepartureAirportName: "Moi International Airport",
                                        DepartureAirportFullName: "Moi International Airport (MBA)",
                                        ArrivalDate: "2024-01-30T14:20:00",
                                        ArrivalAirportCode: "NBO",
                                        ArrivalAirportName: "Jomo Kenyatta International Airport",
                                        ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "0",
                                        BaggageUnit: "",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 8960.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9880.0,
                        Taxes: 4920.0,
                        GdsFees: 0.0,
                        TotalFare: 10525.0,
                        OriginalTotalFare: 10525.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4920.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4960.0,
                                TotalFare: 10525.0,
                                GdsTotalFare: 9880.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4960.0,
                                OriginalGdsTotalFare: 9880.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10525.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 0,
                            RecommendationID: 2,
                            OWNER: "KQ",
                            OFFER_ID: "SP2F-17828000861282643849-5",
                            FLIGHT_KEY: "KQ-FLT5",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "2b324018d21f408d99e514c34a7a14e3",
                            GdsCombinationID: 9,
                            GdsRecommendationID: 9,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 1,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-30T14:45:00",
                                DepartureAirportCode: "MBA",
                                DepartureAirportName: "Moi International Airport",
                                DepartureAirportFullName: "Moi International Airport (MBA)",
                                ArrivalDate: "2024-01-30T15:45:00",
                                ArrivalAirportCode: "NBO",
                                ArrivalAirportName: "Jomo Kenyatta International Airport",
                                ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG7",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1D",
                                        DepartureTerminalName: "1",
                                        DepartureDate: "2024-01-30T14:45:00",
                                        DepartureAirportCode: "MBA",
                                        DepartureAirportName: "Moi International Airport",
                                        DepartureAirportFullName: "Moi International Airport (MBA)",
                                        ArrivalDate: "2024-01-30T15:45:00",
                                        ArrivalAirportCode: "NBO",
                                        ArrivalAirportName: "Jomo Kenyatta International Airport",
                                        ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "0",
                                        BaggageUnit: "",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 9960.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 9880.0,
                        Taxes: 4920.0,
                        GdsFees: 0.0,
                        TotalFare: 10525.0,
                        OriginalTotalFare: 10525.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4920.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 4960.0,
                                TotalFare: 10525.0,
                                GdsTotalFare: 9880.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 4960.0,
                                OriginalGdsTotalFare: 9880.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 10525.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 0,
                            RecommendationID: 3,
                            OWNER: "KQ",
                            OFFER_ID: "SP2F-17828000861282643849-6",
                            FLIGHT_KEY: "KQ-FLT6",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "2b324018d21f408d99e514c34a7a14e3",
                            GdsCombinationID: 9,
                            GdsRecommendationID: 9,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 1,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-30T18:45:00",
                                DepartureAirportCode: "MBA",
                                DepartureAirportName: "Moi International Airport",
                                DepartureAirportFullName: "Moi International Airport (MBA)",
                                ArrivalDate: "2024-01-30T19:45:00",
                                ArrivalAirportCode: "NBO",
                                ArrivalAirportName: "Jomo Kenyatta International Airport",
                                ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG9",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1D",
                                        DepartureTerminalName: "1",
                                        DepartureDate: "2024-01-30T18:45:00",
                                        DepartureAirportCode: "MBA",
                                        DepartureAirportName: "Moi International Airport",
                                        DepartureAirportFullName: "Moi International Airport (MBA)",
                                        ArrivalDate: "2024-01-30T19:45:00",
                                        ArrivalAirportCode: "NBO",
                                        ArrivalAirportName: "Jomo Kenyatta International Airport",
                                        ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "0",
                                        BaggageUnit: "",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 10640.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 13560.0,
                        Taxes: 4920.0,
                        GdsFees: 0.0,
                        TotalFare: 14205.0,
                        OriginalTotalFare: 14205.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4920.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 8640.0,
                                TotalFare: 14205.0,
                                GdsTotalFare: 13560.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 8640.0,
                                OriginalGdsTotalFare: 13560.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 14205.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 0,
                            RecommendationID: 5,
                            OWNER: "KQ",
                            OFFER_ID: "SP2F-17828000861282643849-8",
                            FLIGHT_KEY: "KQ-FLT8",
                            PRICE_CLASS_REFERENCE: "KQ-BESTBUYKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "2b324018d21f408d99e514c34a7a14e3",
                            GdsCombinationID: 13,
                            GdsRecommendationID: 9,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 1,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-30T12:05:00",
                                DepartureAirportCode: "MBA",
                                DepartureAirportName: "Moi International Airport",
                                DepartureAirportFullName: "Moi International Airport (MBA)",
                                ArrivalDate: "2024-01-30T13:05:00",
                                ArrivalAirportCode: "NBO",
                                ArrivalAirportName: "Jomo Kenyatta International Airport",
                                ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG5",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1D",
                                        DepartureTerminalName: "1",
                                        DepartureDate: "2024-01-30T12:05:00",
                                        DepartureAirportCode: "MBA",
                                        DepartureAirportName: "Moi International Airport",
                                        DepartureAirportFullName: "Moi International Airport (MBA)",
                                        ArrivalDate: "2024-01-30T13:05:00",
                                        ArrivalAirportCode: "NBO",
                                        ArrivalAirportName: "Jomo Kenyatta International Airport",
                                        ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "0",
                                        BaggageUnit: "",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 12435.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 14355.0,
                        Taxes: 4920.0,
                        GdsFees: 0.0,
                        TotalFare: 15000.0,
                        OriginalTotalFare: 15000.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4920.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 9435.0,
                                TotalFare: 15000.0,
                                GdsTotalFare: 14355.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 9435.0,
                                OriginalGdsTotalFare: 14355.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 15000.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 0,
                            RecommendationID: 6,
                            OWNER: "KQ",
                            OFFER_ID: "SP2F-17828000861282643849-12",
                            FLIGHT_KEY: "KQ-FLT4",
                            PRICE_CLASS_REFERENCE: "KQ-ECOSTDKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "2b324018d21f408d99e514c34a7a14e3",
                            GdsCombinationID: 23,
                            GdsRecommendationID: 9,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 1,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                Duration: "1h:00m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-30T16:45:00",
                                DepartureAirportCode: "MBA",
                                DepartureAirportName: "Moi International Airport",
                                DepartureAirportFullName: "Moi International Airport (MBA)",
                                ArrivalDate: "2024-01-30T17:45:00",
                                ArrivalAirportCode: "NBO",
                                ArrivalAirportName: "Jomo Kenyatta International Airport",
                                ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG8",
                                        Aircraft: null,
                                        MarketingAirlineCode: "KQ",
                                        MarketingAirlineName: "Kenya Airways",
                                        OperatingAirlineCode: "KQ",
                                        OperatingAirlineName: "Kenya Airways",
                                        ArrivalTerminalName: "1D",
                                        DepartureTerminalName: "1",
                                        DepartureDate: "2024-01-30T16:45:00",
                                        DepartureAirportCode: "MBA",
                                        DepartureAirportName: "Moi International Airport",
                                        DepartureAirportFullName: "Moi International Airport (MBA)",
                                        ArrivalDate: "2024-01-30T17:45:00",
                                        ArrivalAirportCode: "NBO",
                                        ArrivalAirportName: "Jomo Kenyatta International Airport",
                                        ArrivalAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                        FlightDuration: "1h:00m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "1h:00m",
                                        FlightClass: "Economy",
                                        Baggages: "0",
                                        BaggageUnit: "",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 13435.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 14355.0,
                        Taxes: 4920.0,
                        GdsFees: 0.0,
                        TotalFare: 15000.0,
                        OriginalTotalFare: 15000.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4920.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 9435.0,
                                TotalFare: 15000.0,
                                GdsTotalFare: 14355.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 9435.0,
                                OriginalGdsTotalFare: 14355.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 15000.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 0,
                            RecommendationID: 7,
                            OWNER: "KQ",
                            OFFER_ID: "SP2F-17828000861282643849-15",
                            FLIGHT_KEY: "KQ-FLT7",
                            PRICE_CLASS_REFERENCE: "KQ-ECOSTDKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "2b324018d21f408d99e514c34a7a14e3",
                            GdsCombinationID: 23,
                            GdsRecommendationID: 9,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 1,
                    },
                    {
                        FlightDetails: [
                            {
                                OperatingAirlineCode: "BA",
                                OperatingAirlineName: "British Airways",
                                MarketingAirlineCode: "BA",
                                MarketingAirlineName: "British Airways",

                                Duration: "2h:15m",
                                StopOvers: 0,
                                DepartureDate: "2024-01-20T14:30:00",
                                DepartureAirportCode: "LHR",
                                DepartureAirportName: "Heathrow Airport",
                                DepartureAirportFullName: "Heathrow Airport, (LHR)",
                                ArrivalDate: "2024-01-20T18:45:00",
                                ArrivalAirportCode: "JFK",
                                ArrivalAirportName: "John F. Kennedy International Airport",
                                ArrivalAirportFullName: "John F. Kennedy International Airport, (JFK)",
                                FlightEntries: [
                                    {
                                        FlightNumber: "KQ-SEG10",
                                        Aircraft: null,

                                        OperatingAirlineCode: "BA",
                                        OperatingAirlineName: "British Airways",
                                        MarketingAirlineCode: "BA",
                                        MarketingAirlineName: "British Airways",

                                        ArrivalTerminalName: "1D",
                                        DepartureTerminalName: "1",
                                        DepartureDate: "2024-01-30T20:45:00",

                                        DepartureAirportCode: "LHR",
                                        DepartureAirportName: "Heathrow Airport",
                                        DepartureAirportFullName: "Heathrow Airport, (LHR)",
                                        ArrivalDate: "2024-01-20T18:45:00",
                                        ArrivalAirportCode: "JFK",
                                        ArrivalAirportName: "John F. Kennedy International Airport",
                                        ArrivalAirportFullName: "John F. Kennedy International Airport, (JFK)",

                                        FlightDuration: "2h:15m",
                                        HasStopOver: false,
                                        StopOverDuartion: "0h:00m",
                                        TotalDuration: "2h:15m",
                                        FlightClass: "Premium",
                                        Baggages: "0",
                                        BaggageUnit: "",
                                        BookingCode: "Y",
                                        AvailablePassengerSeats: [],
                                    },
                                ],
                                FlightRules: [],
                            },
                        ],
                        AgentId: 174,
                        GDSId: 105,
                        Currency: "KES",
                        BaseFare: 14235.0,
                        TotalServiceCharge: 645.0,
                        GdsTotalFare: 15155.0,
                        Taxes: 4920.0,
                        GdsFees: 0.0,
                        TotalFare: 15800.0,
                        OriginalTotalFare: 15800.0,
                        IsDiscounted: false,
                        ExchangeRate: null,
                        TicketPurchaseCurrency: "KES",
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Age: null,
                                Quantity: 1,
                                Taxes: 4920.0,
                                Fees: 0.0,
                                ServiceCharge: 645.0,
                                BaseFare: 10235.0,
                                TotalFare: 15800.0,
                                GdsTotalFare: 15155.0,
                                TicketRules: [],
                                OriginalGdsBaseFare: 10235.0,
                                OriginalGdsTotalFare: 15155.0,
                                OriginalAgentMarkupFare: 0.0,
                                OriginalTotalFare: 15800.0,
                            },
                        ],
                        Properties: {
                            CombinationID: 0,
                            RecommendationID: 8,
                            OWNER: "KQ",
                            OFFER_ID: "SP2F-17828000861282643849-17",
                            FLIGHT_KEY: "KQ-FLT9",
                            PRICE_CLASS_REFERENCE: "KQ-ECOSTDKE",
                            EnsureAgentUnicityForRoutes: false,
                            TransportServiceType: 1,
                            TripsSessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
                            GdsSessionId: "2b324018d21f408d99e514c34a7a14e3",
                            GdsCombinationID: 25,
                            GdsRecommendationID: 9,
                        },
                        IsLocal: true,
                        TotalFlightDuration: "1h:00m",
                        FlightRouteIndex: 1,
                    },
                ],
                Errors: null,
            },
        ],
        Errors: null,
    },
    SessionId: "485b38e8f67d4d4098955e10ed0f9e5b",
};

export const internationalRoundTrip = {
    FlightType: "International",
    Errors: null,
    ResponseData: {
        SessionId: "18897e9cfa744735aeb3f8d8febb2129",
        TotalCount: 1,
        ResultList: [
            {
                FlightDetails: [
                    {
                        OperatingAirlineCode: "KL",
                        OperatingAirlineName: "KLM Royal Dutch",
                        MarketingAirlineCode: "KL",
                        MarketingAirlineName: "KLM Royal Dutch",
                        Duration: "16h:10m",
                        StopOvers: 2,
                        DepartureDate: "2024-02-21T22:35:00",
                        DepartureAirportCode: "LOS",
                        DepartureAirportName: "Murtala Muhammed International Airport",
                        DepartureAirportFullName: "Murtala Muhammed International Airport (LOS)",
                        ArrivalDate: "2024-02-22T13:45:00",
                        ArrivalAirportCode: "LHR",
                        ArrivalAirportName: "London Heathrow Airport",
                        ArrivalAirportFullName: "London Heathrow Airport (LHR)",
                        FlightEntries: [
                            {
                                FlightNumber: "5479",
                                Aircraft: "AIRBUS A330-200",
                                MarketingAirlineCode: "KL",
                                MarketingAirlineName: "KLM Royal Dutch",
                                OperatingAirlineCode: "KL",
                                OperatingAirlineName: "KLM Royal Dutch",
                                ArrivalTerminalName: null,
                                DepartureTerminalName: null,
                                DepartureDate: "2024-02-21T22:35:00",
                                DepartureAirportCode: "LOS",
                                DepartureAirportName: "Murtala Muhammed International Airport",
                                DepartureAirportFullName: "Murtala Muhammed International Airport (LOS)",
                                ArrivalDate: "2024-02-22T05:20:00",
                                ArrivalAirportCode: "AMS",
                                ArrivalAirportName: "Amsterdam Airport Schiphol",
                                ArrivalAirportFullName: "Amsterdam Airport Schiphol (AMS)",
                                FlightDuration: "6h:45m",
                                HasStopOver: false,
                                StopOverDuartion: "0h:00m",
                                TotalDuration: "6h:45m",
                                FlightClass: "ECONOMY",
                                Baggages: "1",
                                BaggageUnit: "PC",
                                BookingCode: "E",
                                AvailablePassengerSeats: [
                                    {
                                        PassengerType: "ADT",
                                        PassengerClassCode: "E",
                                        Quantity: "9",
                                        FareBasis: "ERL0JBRA",
                                        FareType: "LIGHTBAG",
                                    },
                                ],
                            },
                            {
                                FlightNumber: "8223",
                                Aircraft: "BOEING 737-900",
                                MarketingAirlineCode: "KL",
                                MarketingAirlineName: "KLM Royal Dutch",
                                OperatingAirlineCode: "KL",
                                OperatingAirlineName: "KLM Royal Dutch",
                                ArrivalTerminalName: null,
                                DepartureTerminalName: null,
                                DepartureDate: "2024-02-22T06:50:00",
                                DepartureAirportCode: "AMS",
                                DepartureAirportName: "Amsterdam Airport Schiphol",
                                DepartureAirportFullName: "Amsterdam Airport Schiphol (AMS)",
                                ArrivalDate: "2024-02-22T08:10:00",
                                ArrivalAirportCode: "CDG",
                                ArrivalAirportName: "Charles de Gaulle Airport (Roissy Airport)",
                                ArrivalAirportFullName: "Charles de Gaulle Airport (Roissy Airport) (CDG)",
                                FlightDuration: "1h:20m",
                                HasStopOver: true,
                                StopOverDuartion: "1h:30m",
                                TotalDuration: "2h:50m",
                                FlightClass: "ECONOMY",
                                Baggages: "1",
                                BaggageUnit: "PC",
                                BookingCode: "L",
                                AvailablePassengerSeats: [
                                    {
                                        PassengerType: "ADT",
                                        PassengerClassCode: "L",
                                        Quantity: "9",
                                        FareBasis: "ERL0JBRA",
                                        FareType: "LIGHTBAG",
                                    },
                                ],
                            },
                            {
                                FlightNumber: "1780",
                                Aircraft: "AIRBUS A320",
                                MarketingAirlineCode: "AF",
                                MarketingAirlineName: "Air France",
                                OperatingAirlineCode: "AF",
                                OperatingAirlineName: "Air France",
                                ArrivalTerminalName: null,
                                DepartureTerminalName: null,
                                DepartureDate: "2024-02-22T13:15:00",
                                DepartureAirportCode: "CDG",
                                DepartureAirportName: "Charles de Gaulle Airport (Roissy Airport)",
                                DepartureAirportFullName: "Charles de Gaulle Airport (Roissy Airport) (CDG)",
                                ArrivalDate: "2024-02-22T13:45:00",
                                ArrivalAirportCode: "LHR",
                                ArrivalAirportName: "London Heathrow Airport",
                                ArrivalAirportFullName: "London Heathrow Airport (LHR)",
                                FlightDuration: "1h:30m",
                                HasStopOver: true,
                                StopOverDuartion: "5h:05m",
                                TotalDuration: "6h:35m",
                                FlightClass: "ECONOMY",
                                Baggages: "1",
                                BaggageUnit: "PC",
                                BookingCode: "L",
                                AvailablePassengerSeats: [
                                    {
                                        PassengerType: "ADT",
                                        PassengerClassCode: "L",
                                        Quantity: "9",
                                        FareBasis: "ERL0JBRA",
                                        FareType: "LIGHTBAG",
                                    },
                                ],
                            },
                        ],
                        FlightRules: [],
                    },
                    {
                        OperatingAirlineCode: "AF",
                        OperatingAirlineName: "Air France",
                        MarketingAirlineCode: "AF",
                        MarketingAirlineName: "Air France",
                        Duration: "30h:10m",
                        StopOvers: 1,
                        DepartureDate: "2024-03-30T15:00:00",
                        DepartureAirportCode: "LHR",
                        DepartureAirportName: "London Heathrow Airport",
                        DepartureAirportFullName: "London Heathrow Airport (LHR)",
                        ArrivalDate: "2024-03-31T21:10:00",
                        ArrivalAirportCode: "LOS",
                        ArrivalAirportName: "Murtala Muhammed International Airport",
                        ArrivalAirportFullName: "Murtala Muhammed International Airport (LOS)",
                        FlightEntries: [
                            {
                                FlightNumber: "1781",
                                Aircraft: "AIRBUS A320",
                                MarketingAirlineCode: "AF",
                                MarketingAirlineName: "Air France",
                                OperatingAirlineCode: "AF",
                                OperatingAirlineName: "Air France",
                                ArrivalTerminalName: null,
                                DepartureTerminalName: null,
                                DepartureDate: "2024-03-30T15:00:00",
                                DepartureAirportCode: "LHR",
                                DepartureAirportName: "London Heathrow Airport",
                                DepartureAirportFullName: "London Heathrow Airport (LHR)",
                                ArrivalDate: "2024-03-30T17:20:00",
                                ArrivalAirportCode: "CDG",
                                ArrivalAirportName: "Charles de Gaulle Airport (Roissy Airport)",
                                ArrivalAirportFullName: "Charles de Gaulle Airport (Roissy Airport) (CDG)",
                                FlightDuration: "1h:20m",
                                HasStopOver: false,
                                StopOverDuartion: "0h:00m",
                                TotalDuration: "1h:20m",
                                FlightClass: "ECONOMY",
                                Baggages: "1",
                                BaggageUnit: "PC",
                                BookingCode: "L",
                                AvailablePassengerSeats: [
                                    {
                                        PassengerType: "ADT",
                                        PassengerClassCode: "L",
                                        Quantity: "9",
                                        FareBasis: "NRL0JBRA",
                                        FareType: "LIGHTBAG",
                                    },
                                ],
                            },
                            {
                                FlightNumber: "132",
                                Aircraft: "AIRBUS A350-900",
                                MarketingAirlineCode: "AF",
                                MarketingAirlineName: "Air France",
                                OperatingAirlineCode: "AF",
                                OperatingAirlineName: "Air France",
                                ArrivalTerminalName: null,
                                DepartureTerminalName: null,
                                DepartureDate: "2024-03-31T16:05:00",
                                DepartureAirportCode: "CDG",
                                DepartureAirportName: "Charles de Gaulle Airport (Roissy Airport)",
                                DepartureAirportFullName: "Charles de Gaulle Airport (Roissy Airport) (CDG)",
                                ArrivalDate: "2024-03-31T21:10:00",
                                ArrivalAirportCode: "LOS",
                                ArrivalAirportName: "Murtala Muhammed International Airport",
                                ArrivalAirportFullName: "Murtala Muhammed International Airport (LOS)",
                                FlightDuration: "6h:05m",
                                HasStopOver: true,
                                StopOverDuartion: "22h:45m",
                                TotalDuration: "28h:50m",
                                FlightClass: "ECONOMY",
                                Baggages: "1",
                                BaggageUnit: "PC",
                                BookingCode: "N",
                                AvailablePassengerSeats: [
                                    {
                                        PassengerType: "ADT",
                                        PassengerClassCode: "N",
                                        Quantity: "9",
                                        FareBasis: "NRL0JBRA",
                                        FareType: "LIGHTBAG",
                                    },
                                ],
                            },
                        ],
                        FlightRules: [],
                    },
                ],
                AgentId: 141,
                GDSId: 99,
                Currency: "KES",
                BaseFare: 36475.0,
                TotalServiceCharge: 3.0,
                GdsTotalFare: 142650.0,
                Taxes: 106175.0,
                GdsFees: 0.0,
                TotalFare: 147653.0,
                OriginalTotalFare: 147653.0,
                IsDiscounted: false,
                ExchangeRate: null,
                TicketPurchaseCurrency: "KES",
                PassengerFares: [
                    {
                        PassengerType: "ADT",
                        Age: null,
                        Quantity: 1,
                        Taxes: 106175.0,
                        Fees: 0.0,
                        ServiceCharge: 3.0,
                        BaseFare: 36475.0,
                        TotalFare: 147653.0,
                        GdsTotalFare: 142650.0,
                        TicketRules: [],
                        OriginalGdsBaseFare: 36475.0,
                        OriginalGdsTotalFare: 142650.0,
                        OriginalAgentMarkupFare: 0.0,
                        OriginalTotalFare: 147653.0,
                    },
                ],
                Properties: {
                    CombinationID: 0,
                    RecommendationID: 0,
                    EnsureAgentUnicityForRoutes: false,
                    TransportServiceType: 2,
                    TripsSessionId: "18897e9cfa744735aeb3f8d8febb2129",
                    GdsSessionId: "378c9a5eaced4210905c44f0043f0d80",
                    GdsCombinationID: 4,
                    GdsRecommendationID: 4,
                },
                IsLocal: false,
                TotalFlightDuration: "46h:20m",
                FlightRouteIndex: 0,
            },
            {
                FlightDetails: [
                    {
                        OperatingAirlineCode: "KQ",
                        OperatingAirlineName: "Kenya Airways",
                        MarketingAirlineCode: "KQ",
                        MarketingAirlineName: "Kenya Airways",
                        Duration: "8h:55m",
                        StopOvers: 0,
                        DepartureDate: "2024-01-25T01:55:00",
                        DepartureAirportCode: "NBO",
                        DepartureAirportName: "Jomo Kenyatta International Airport",
                        DepartureAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                        ArrivalDate: "2024-01-25T07:50:00",
                        ArrivalAirportCode: "LHR",
                        ArrivalAirportName: "London Heathrow Airport",
                        ArrivalAirportFullName: "London Heathrow Airport (LHR)",
                        FlightEntries: [
                            {
                                FlightNumber: "102",
                                Aircraft: "BOEING 787-8",
                                MarketingAirlineCode: "KQ",
                                MarketingAirlineName: "Kenya Airways",
                                OperatingAirlineCode: "KQ",
                                OperatingAirlineName: "Kenya Airways",
                                ArrivalTerminalName: null,
                                DepartureTerminalName: null,
                                DepartureDate: "2024-01-25T01:55:00",
                                DepartureAirportCode: "NBO",
                                DepartureAirportName: "Jomo Kenyatta International Airport",
                                DepartureAirportFullName: "Jomo Kenyatta International Airport (NBO)",
                                ArrivalDate: "2024-01-25T07:50:00",
                                ArrivalAirportCode: "LHR",
                                ArrivalAirportName: "London Heathrow Airport",
                                ArrivalAirportFullName: "London Heathrow Airport (LHR)",
                                FlightDuration: "8h:55m",
                                HasStopOver: false,
                                StopOverDuartion: "0h:00m",
                                TotalDuration: "8h:55m",
                                FlightClass: "ECONOMY",
                                Baggages: "2",
                                BaggageUnit: "PC",
                                BookingCode: "L",
                                AvailablePassengerSeats: [
                                    {
                                        PassengerType: "ADT",
                                        PassengerClassCode: "L",
                                        Quantity: "9",
                                        FareBasis: null,
                                        FareType: null,
                                    },
                                ],
                            },
                        ],
                        FlightRules: [],
                    },
                ],
                AgentId: 8,
                GDSId: 6,
                Currency: "KES",
                TotalServiceCharge: 3044,
                TotalFare: 144614,
                OriginalTotalFare: 144614,
                ExchangeRate: null,
                TicketPurchaseCurrency: null,
                PassengerFares: [
                    {
                        PassengerType: "ADT",
                        Age: null,
                        Quantity: 1,
                        ServiceCharge: 3044,
                        TotalFare: 144614,
                        TicketRules: [],
                        OriginalGdsBaseFare: 0,
                        OriginalGdsTotalFare: 0,
                        OriginalAgentMarkupFare: 0,
                        OriginalTotalFare: 144614,
                    },
                ],
                Properties: {
                    CombinationID: 0,
                    RecommendationID: 11,
                    EnsureAgentUnicityForRoutes: false,
                    TransportServiceType: 2,
                    TripsSessionId: "6c0869b17e7f4489a999b921e3521c1b",
                    GdsSessionId: "d8eeda5999044b008c75b256278d434e",
                    GdsCombinationID: 90,
                    GdsRecommendationID: 90,
                },
                IsLocal: false,
                TotalFlightDuration: "8h:55m",
                FlightRouteIndex: 0,
            },
        ],
        Errors: null,
    },
    SessionId: "18897e9cfa744735aeb3f8d8febb2129",
};


// Road Payload
export const AvailableSeats = [
    {
        "IsAvailable": true,
        "SeatNumber": "1",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "2",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "VIP"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "3",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Business"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "4",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "5",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "6",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Business"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "7",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "8",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "9",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "10",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "11",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "12",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "13",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "14",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "15",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "16",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "17",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "18",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "19",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "20",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "21",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "22",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "23",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "24",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "25",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "26",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "27",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "28",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "29",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "30",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "31",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "32",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "33",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "34",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "35",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "36",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "37",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "38",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "39",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "40",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "41",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "42",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "43",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "44",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "45",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "46",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "47",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "48",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "49",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "50",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "51",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "52",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    },
    {
        "IsAvailable": true,
        "SeatNumber": "53",
        "Price": 1890.000000,
        "IntPrice": 1890,
        "Row": 0,
        "Column": 0,
        "Id": null,
        "Class": "Normal"
    }
];

export const BusResultList = {
    TripsSessionId: "cc237c91ce5349278dc5a22aabe883eb",
    Currency: "NGN",
    IsLocal: true,
    FirstLeg: {
        TotalCount: 1,
        ResultList: [
            {
                CombinationId: 0,
                SessionId: "cc237c91ce5349278dc5a22aabe883eb",
                GdsId: 102,
                AgentId: 168,
                Currency: "KES",
                TicketPurchaseCurrency: "NGN",
                AgentName: "ABC Transport",
                StartingPrice: 1890.0,
                IsLocal: true,
                Stops: 0,
                DepartureTerminal: "Lagos (Jibowu)",
                ArrivalTerminal: "Abuja",
                ArrivalTerminalId: 68,
                DepartureTerminalId: 72,
                DepartureDate: "2023-11-18T00:00:00",
                BusRouteIndex: 0,
                AvailableBuses: [
                    {
                        RecommendationId: 0,
                        BusType: "2+2, Executive Express, AC, Non-Video",
                        EstimatedDepartureDate: "2023-11-18T06:00:00",
                        EstimatedDepartureTime: "06:00",
                        EstimatedArrivalDate: "2023-11-18T14:30:00",
                        EstimatedArrivalTime: "14:30",
                        DepartureDate: "2023-11-18T00:00:00",
                        Duration: "08:30",
                        TotalAvailableSeats: 53,
                        Currency: "NGN",
                        ReservationId: "12163",
                        BoardingDetails: {
                            Id: "4",
                            Time: "06:00",
                            Address: "x",
                            LandMark: "X",
                            ContactNumber: "0",
                            Name: "Jibowu",
                        },
                        DropOffDetails: {
                            Id: "3",
                            Time: "14:30",
                            Address: "x",
                            LandMark: "X",
                            ContactNumber: "3333",
                            Name: "Abuja",
                        },
                        AvailableSeats: [
                            { IsAvailable: true, SeatNumber: "1", Price: 1890, IntPrice: 1890, Row: 0, Column: 0, Id: null, Class: "VIP" },
                            { IsAvailable: true, SeatNumber: "2", Price: 1890, IntPrice: 1890, Row: 0, Column: 1, Id: null, Class: "VIP" },
                            { IsAvailable: true, SeatNumber: "3", Price: 1890, IntPrice: 1890, Row: 0, Column: 2, Id: null, Class: "VIP" },
                            { IsAvailable: true, SeatNumber: "4", Price: 1890, IntPrice: 1890, Row: 0, Column: 3, Id: null, Class: "VIP" },
                            { IsAvailable: true, SeatNumber: "5", Price: 1890, IntPrice: 1890, Row: 1, Column: 0, Id: null, Class: "Business" },
                            { IsAvailable: true, SeatNumber: "6", Price: 1890, IntPrice: 1890, Row: 1, Column: 1, Id: null, Class: "Business" },
                            { IsAvailable: true, SeatNumber: "7", Price: 1890, IntPrice: 1890, Row: 1, Column: 2, Id: null, Class: "Business" },
                            { IsAvailable: true, SeatNumber: "8", Price: 1890, IntPrice: 1890, Row: 1, Column: 3, Id: null, Class: "Business" },
                            { IsAvailable: true, SeatNumber: "9", Price: 1890, IntPrice: 1890, Row: 2, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "10", Price: 1890, IntPrice: 1890, Row: 2, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "11", Price: 1890, IntPrice: 1890, Row: 2, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "12", Price: 1890, IntPrice: 1890, Row: 2, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "13", Price: 1890, IntPrice: 1890, Row: 3, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "14", Price: 1890, IntPrice: 1890, Row: 3, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "15", Price: 1890, IntPrice: 1890, Row: 3, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "16", Price: 1890, IntPrice: 1890, Row: 3, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: false, SeatNumber: "17", Price: 1890, IntPrice: 1890, Row: 4, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "18", Price: 1890, IntPrice: 1890, Row: 4, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "19", Price: 1890, IntPrice: 1890, Row: 4, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: false, SeatNumber: "20", Price: 1890, IntPrice: 1890, Row: 4, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "21", Price: 1890, IntPrice: 1890, Row: 5, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "22", Price: 1890, IntPrice: 1890, Row: 5, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "23", Price: 1890, IntPrice: 1890, Row: 5, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "24", Price: 1890, IntPrice: 1890, Row: 5, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "25", Price: 1890, IntPrice: 1890, Row: 6, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "26", Price: 1890, IntPrice: 1890, Row: 6, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: false, SeatNumber: "27", Price: 1890, IntPrice: 1890, Row: 6, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "28", Price: 1890, IntPrice: 1890, Row: 6, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "29", Price: 1890, IntPrice: 1890, Row: 7, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "30", Price: 1890, IntPrice: 1890, Row: 7, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "31", Price: 1890, IntPrice: 1890, Row: 7, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "32", Price: 1890, IntPrice: 1890, Row: 7, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "33", Price: 1890, IntPrice: 1890, Row: 8, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "34", Price: 1890, IntPrice: 1890, Row: 8, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "35", Price: 1890, IntPrice: 1890, Row: 8, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "36", Price: 1890, IntPrice: 1890, Row: 8, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "37", Price: 1890, IntPrice: 1890, Row: 9, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: false, SeatNumber: "38", Price: 1890, IntPrice: 1890, Row: 9, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "39", Price: 1890, IntPrice: 1890, Row: 9, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "40", Price: 1890, IntPrice: 1890, Row: 9, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "41", Price: 1890, IntPrice: 1890, Row: 10, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "42", Price: 1890, IntPrice: 1890, Row: 10, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "43", Price: 1890, IntPrice: 1890, Row: 10, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "44", Price: 1890, IntPrice: 1890, Row: 10, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "45", Price: 1890, IntPrice: 1890, Row: 11, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "46", Price: 1890, IntPrice: 1890, Row: 11, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "47", Price: 1890, IntPrice: 1890, Row: 11, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "48", Price: 1890, IntPrice: 1890, Row: 11, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "49", Price: 1890, IntPrice: 1890, Row: 12, Column: 0, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "50", Price: 1890, IntPrice: 1890, Row: 12, Column: 1, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "51", Price: 1890, IntPrice: 1890, Row: 12, Column: 2, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "52", Price: 1890, IntPrice: 1890, Row: 12, Column: 3, Id: null, Class: "Normal" },
                            { IsAvailable: true, SeatNumber: "53", Price: 1890, IntPrice: 1890, Row: 13, Column: 0, Id: null, Class: "Normal" },
                        ],
                        PassengerFares: [
                            {
                                PassengerType: "ADT",
                                Taxes: 0,
                                Fees: 0.0,
                                TotalFare: 1951.0,
                                GdsFare: 1890.0,
                                BaseFare: 1890.0,
                                GdsTotalFare: 1890.0,
                                Quantity: 1,
                                MarkupFare: 0,
                                ServiceCharge: 60.95,
                            },
                        ],
                        Capacity: 53,
                        Row: 14,
                        Column: 4,
                        TotalFare: 1951.0,
                    },
                ],
            },
        ],
    },
    SecondLeg: {
        TotalCount: 0,
        ResultList: [],
    },
};


const flightData = {
    "SessionId": "6c0869b17e7f4489a999b921e3521c1b",
    "TotalCount": 17,
    "ResultList": [
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "WB",
                    "OperatingAirlineName": "Rwandair",
                    "MarketingAirlineCode": "WB",
                    "MarketingAirlineName": "Rwandair",
                    "Duration": "12h:45m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T20:50:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-26T06:35:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "403",
                            "Aircraft": "DE HAVILLAND DHC-8 400 SERIES",
                            "MarketingAirlineCode": "WB",
                            "MarketingAirlineName": "Rwandair",
                            "OperatingAirlineCode": "WB",
                            "OperatingAirlineName": "Rwandair",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T20:50:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T21:30:00",
                            "ArrivalAirportCode": "KGL",
                            "ArrivalAirportName": "Kigali International Airport (Kanombe Airport)",
                            "ArrivalAirportFullName": "Kigali International Airport (Kanombe Airport) (KGL)",
                            "FlightDuration": "1h:40m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "1h:40m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "M",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "M",
                                    "Quantity": "1",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "710",
                            "Aircraft": "AIRBUS A330-300",
                            "MarketingAirlineCode": "WB",
                            "MarketingAirlineName": "Rwandair",
                            "OperatingAirlineCode": "WB",
                            "OperatingAirlineName": "Rwandair",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T23:35:00",
                            "DepartureAirportCode": "KGL",
                            "DepartureAirportName": "Kigali International Airport (Kanombe Airport)",
                            "DepartureAirportFullName": "Kigali International Airport (Kanombe Airport) (KGL)",
                            "ArrivalDate": "2024-01-26T06:35:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "9h:00m",
                            "HasStopOver": true,
                            "StopOverDuartion": "2h:05m",
                            "TotalDuration": "11h:05m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "M",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "M",
                                    "Quantity": "1",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 1839,
            "TotalFare": 87369,
            "OriginalTotalFare": 87369,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 1839,
                    "TotalFare": 87369,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 87369
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 0,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 1,
                "GdsRecommendationID": 1
            },
            "IsLocal": false,
            "TotalFlightDuration": "12h:45m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "TK",
                    "OperatingAirlineName": "Turkish Airline",
                    "MarketingAirlineCode": "TK",
                    "MarketingAirlineName": "Turkish Airline",
                    "Duration": "12h:35m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T05:05:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-25T14:40:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "608",
                            "Aircraft": "AIRBUS A330-200",
                            "MarketingAirlineCode": "TK",
                            "MarketingAirlineName": "Turkish Airline",
                            "OperatingAirlineCode": "TK",
                            "OperatingAirlineName": "Turkish Airline",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T05:05:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T12:20:00",
                            "ArrivalAirportCode": "IST",
                            "ArrivalAirportName": "Istanbul Atatürk Airport (Yesilköy International)",
                            "ArrivalAirportFullName": "Istanbul Atatürk Airport (Yesilköy International) (IST)",
                            "FlightDuration": "7h:15m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "7h:15m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "T",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "T",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "1985",
                            "Aircraft": "AIRBUS A330-300",
                            "MarketingAirlineCode": "TK",
                            "MarketingAirlineName": "Turkish Airline",
                            "OperatingAirlineCode": "TK",
                            "OperatingAirlineName": "Turkish Airline",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T13:40:00",
                            "DepartureAirportCode": "IST",
                            "DepartureAirportName": "Istanbul Atatürk Airport (Yesilköy International)",
                            "DepartureAirportFullName": "Istanbul Atatürk Airport (Yesilköy International) (IST)",
                            "ArrivalDate": "2024-01-25T14:40:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "4h:00m",
                            "HasStopOver": true,
                            "StopOverDuartion": "1h:20m",
                            "TotalDuration": "5h:20m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "T",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "T",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 1951,
            "TotalFare": 92691,
            "OriginalTotalFare": 92691,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 1951,
                    "TotalFare": 92691,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 92691
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 1,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 2,
                "GdsRecommendationID": 2
            },
            "IsLocal": false,
            "TotalFlightDuration": "12h:35m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "QR",
                    "OperatingAirlineName": "Qatar Airways",
                    "MarketingAirlineCode": "QR",
                    "MarketingAirlineName": "Qatar Airways",
                    "Duration": "13h:40m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T01:35:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-25T12:15:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "1342",
                            "Aircraft": "BOEING 777-300ER",
                            "MarketingAirlineCode": "QR",
                            "MarketingAirlineName": "Qatar Airways",
                            "OperatingAirlineCode": "QR",
                            "OperatingAirlineName": "Qatar Airways",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T01:35:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T06:50:00",
                            "ArrivalAirportCode": "DOH",
                            "ArrivalAirportName": "Hamad International Airport",
                            "ArrivalAirportFullName": "Hamad International Airport (DOH)",
                            "FlightDuration": "5h:15m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "5h:15m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "N",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "N",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "3",
                            "Aircraft": "BOEING 777-300ER",
                            "MarketingAirlineCode": "QR",
                            "MarketingAirlineName": "Qatar Airways",
                            "OperatingAirlineCode": "QR",
                            "OperatingAirlineName": "Qatar Airways",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T07:40:00",
                            "DepartureAirportCode": "DOH",
                            "DepartureAirportName": "Hamad International Airport",
                            "DepartureAirportFullName": "Hamad International Airport (DOH)",
                            "ArrivalDate": "2024-01-25T12:15:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "7h:35m",
                            "HasStopOver": true,
                            "StopOverDuartion": "0h:50m",
                            "TotalDuration": "8h:25m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "N",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "N",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 1984,
            "TotalFare": 94219,
            "OriginalTotalFare": 94219,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 1984,
                    "TotalFare": 94219,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 94219
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 3,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 5,
                "GdsRecommendationID": 5
            },
            "IsLocal": false,
            "TotalFlightDuration": "13h:40m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "QR",
                    "OperatingAirlineName": "Qatar Airways",
                    "MarketingAirlineCode": "QR",
                    "MarketingAirlineName": "Qatar Airways",
                    "Duration": "21h:05m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T17:45:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-26T11:50:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "1336",
                            "Aircraft": "BOEING 777-300ER",
                            "MarketingAirlineCode": "QR",
                            "MarketingAirlineName": "Qatar Airways",
                            "OperatingAirlineCode": "QR",
                            "OperatingAirlineName": "Qatar Airways",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T17:45:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T23:15:00",
                            "ArrivalAirportCode": "DOH",
                            "ArrivalAirportName": "Hamad International Airport",
                            "ArrivalAirportFullName": "Hamad International Airport (DOH)",
                            "FlightDuration": "5h:30m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "5h:30m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "N",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "N",
                                    "Quantity": "1",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "9709",
                            "Aircraft": "BOEING 777-200/300",
                            "MarketingAirlineCode": "BA",
                            "MarketingAirlineName": "British Airways",
                            "OperatingAirlineCode": "BA",
                            "OperatingAirlineName": "British Airways",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-26T07:15:00",
                            "DepartureAirportCode": "DOH",
                            "DepartureAirportName": "Hamad International Airport",
                            "DepartureAirportFullName": "Hamad International Airport (DOH)",
                            "ArrivalDate": "2024-01-26T11:50:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "7h:35m",
                            "HasStopOver": true,
                            "StopOverDuartion": "8h:00m",
                            "TotalDuration": "15h:35m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "N",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "N",
                                    "Quantity": "1",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 1984,
            "TotalFare": 94219,
            "OriginalTotalFare": 94219,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 1984,
                    "TotalFare": 94219,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 94219
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 2,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 9,
                "GdsRecommendationID": 9
            },
            "IsLocal": false,
            "TotalFlightDuration": "21h:05m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "EK",
                    "OperatingAirlineName": "Emirates Airline",
                    "MarketingAirlineCode": "EK",
                    "MarketingAirlineName": "Emirates Airline",
                    "Duration": "30h:15m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T16:45:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-26T20:00:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "720",
                            "Aircraft": "BOEING 777-300ER",
                            "MarketingAirlineCode": "EK",
                            "MarketingAirlineName": "Emirates Airline",
                            "OperatingAirlineCode": "EK",
                            "OperatingAirlineName": "Emirates Airline",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T16:45:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T22:45:00",
                            "ArrivalAirportCode": "DXB",
                            "ArrivalAirportName": "Dubai International Airport",
                            "ArrivalAirportFullName": "Dubai International Airport (DXB)",
                            "FlightDuration": "5h:00m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "5h:00m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "Q",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "Q",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "5",
                            "Aircraft": "AIRBUS A380-800",
                            "MarketingAirlineCode": "EK",
                            "MarketingAirlineName": "Emirates Airline",
                            "OperatingAirlineCode": "EK",
                            "OperatingAirlineName": "Emirates Airline",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-26T16:05:00",
                            "DepartureAirportCode": "DXB",
                            "DepartureAirportName": "Dubai International Airport",
                            "DepartureAirportFullName": "Dubai International Airport (DXB)",
                            "ArrivalDate": "2024-01-26T20:00:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "7h:55m",
                            "HasStopOver": true,
                            "StopOverDuartion": "17h:20m",
                            "TotalDuration": "25h:15m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "Q",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "Q",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 2038,
            "TotalFare": 96813,
            "OriginalTotalFare": 96813,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 2038,
                    "TotalFare": 96813,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 96813
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 5,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 25,
                "GdsRecommendationID": 25
            },
            "IsLocal": false,
            "TotalFlightDuration": "30h:15m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "EK",
                    "OperatingAirlineName": "Emirates Airline",
                    "MarketingAirlineCode": "EK",
                    "MarketingAirlineName": "Emirates Airline",
                    "Duration": "35h:25m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T22:45:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-27T07:10:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "722",
                            "Aircraft": "BOEING 777-300ER",
                            "MarketingAirlineCode": "EK",
                            "MarketingAirlineName": "Emirates Airline",
                            "OperatingAirlineCode": "EK",
                            "OperatingAirlineName": "Emirates Airline",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T22:45:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-26T04:45:00",
                            "ArrivalAirportCode": "DXB",
                            "ArrivalAirportName": "Dubai International Airport",
                            "ArrivalAirportFullName": "Dubai International Airport (DXB)",
                            "FlightDuration": "5h:00m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "5h:00m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "Q",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "Q",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "7",
                            "Aircraft": "AIRBUS A380-800",
                            "MarketingAirlineCode": "EK",
                            "MarketingAirlineName": "Emirates Airline",
                            "OperatingAirlineCode": "EK",
                            "OperatingAirlineName": "Emirates Airline",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-27T03:10:00",
                            "DepartureAirportCode": "DXB",
                            "DepartureAirportName": "Dubai International Airport",
                            "DepartureAirportFullName": "Dubai International Airport (DXB)",
                            "ArrivalDate": "2024-01-27T07:10:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "8h:00m",
                            "HasStopOver": true,
                            "StopOverDuartion": "22h:25m",
                            "TotalDuration": "30h:25m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "Q",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "Q",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 2038,
            "TotalFare": 96813,
            "OriginalTotalFare": 96813,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 2038,
                    "TotalFare": 96813,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 96813
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 4,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 26,
                "GdsRecommendationID": 26
            },
            "IsLocal": false,
            "TotalFlightDuration": "35h:25m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "WB",
                    "OperatingAirlineName": "Rwandair",
                    "MarketingAirlineCode": "WB",
                    "MarketingAirlineName": "Rwandair",
                    "Duration": "28h:05m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T05:30:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-26T06:35:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "464",
                            "Aircraft": "CANADAIR REGIONAL JET",
                            "MarketingAirlineCode": "WB",
                            "MarketingAirlineName": "Rwandair",
                            "OperatingAirlineCode": "WB",
                            "OperatingAirlineName": "Rwandair",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T05:30:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T06:00:00",
                            "ArrivalAirportCode": "KGL",
                            "ArrivalAirportName": "Kigali International Airport (Kanombe Airport)",
                            "ArrivalAirportFullName": "Kigali International Airport (Kanombe Airport) (KGL)",
                            "FlightDuration": "1h:30m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "1h:30m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "M",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "M",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "710",
                            "Aircraft": "AIRBUS A330-300",
                            "MarketingAirlineCode": "WB",
                            "MarketingAirlineName": "Rwandair",
                            "OperatingAirlineCode": "WB",
                            "OperatingAirlineName": "Rwandair",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T23:35:00",
                            "DepartureAirportCode": "KGL",
                            "DepartureAirportName": "Kigali International Airport (Kanombe Airport)",
                            "DepartureAirportFullName": "Kigali International Airport (Kanombe Airport) (KGL)",
                            "ArrivalDate": "2024-01-26T06:35:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "9h:00m",
                            "HasStopOver": true,
                            "StopOverDuartion": "17h:35m",
                            "TotalDuration": "26h:35m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "M",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "M",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 2189,
            "TotalFare": 103964,
            "OriginalTotalFare": 103964,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 2189,
                    "TotalFare": 103964,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 103964
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 7,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 30,
                "GdsRecommendationID": 30
            },
            "IsLocal": false,
            "TotalFlightDuration": "28h:05m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "WB",
                    "OperatingAirlineName": "Rwandair",
                    "MarketingAirlineCode": "WB",
                    "MarketingAirlineName": "Rwandair",
                    "Duration": "20h:35m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T13:00:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-26T06:35:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "453",
                            "Aircraft": "DE HAVILLAND DHC-8 400 SERIES",
                            "MarketingAirlineCode": "WB",
                            "MarketingAirlineName": "Rwandair",
                            "OperatingAirlineCode": "WB",
                            "OperatingAirlineName": "Rwandair",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T13:00:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T13:40:00",
                            "ArrivalAirportCode": "KGL",
                            "ArrivalAirportName": "Kigali International Airport (Kanombe Airport)",
                            "ArrivalAirportFullName": "Kigali International Airport (Kanombe Airport) (KGL)",
                            "FlightDuration": "1h:40m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "1h:40m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "M",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "M",
                                    "Quantity": "2",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "710",
                            "Aircraft": "AIRBUS A330-300",
                            "MarketingAirlineCode": "WB",
                            "MarketingAirlineName": "Rwandair",
                            "OperatingAirlineCode": "WB",
                            "OperatingAirlineName": "Rwandair",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T23:35:00",
                            "DepartureAirportCode": "KGL",
                            "DepartureAirportName": "Kigali International Airport (Kanombe Airport)",
                            "DepartureAirportFullName": "Kigali International Airport (Kanombe Airport) (KGL)",
                            "ArrivalDate": "2024-01-26T06:35:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "9h:00m",
                            "HasStopOver": true,
                            "StopOverDuartion": "9h:55m",
                            "TotalDuration": "18h:55m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "M",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "M",
                                    "Quantity": "2",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 2189,
            "TotalFare": 103964,
            "OriginalTotalFare": 103964,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 2189,
                    "TotalFare": 103964,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 103964
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 6,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 29,
                "GdsRecommendationID": 29
            },
            "IsLocal": false,
            "TotalFlightDuration": "20h:35m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "LH",
                    "OperatingAirlineName": "Lufthansa German Airlines",
                    "MarketingAirlineCode": "LH",
                    "MarketingAirlineName": "Lufthansa German Airlines",
                    "Duration": "13h:50m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T23:55:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-26T10:45:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "591",
                            "Aircraft": "AIRBUS A340-300",
                            "MarketingAirlineCode": "LH",
                            "MarketingAirlineName": "Lufthansa German Airlines",
                            "OperatingAirlineCode": "LH",
                            "OperatingAirlineName": "Lufthansa German Airlines",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T23:55:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-26T07:00:00",
                            "ArrivalAirportCode": "FRA",
                            "ArrivalAirportName": "Frankfurt Airport",
                            "ArrivalAirportFullName": "Frankfurt Airport (FRA)",
                            "FlightDuration": "9h:05m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "9h:05m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "1",
                            "BaggageUnit": "PC",
                            "BookingCode": "V",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "V",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "904",
                            "Aircraft": "AIRBUS A321NEO",
                            "MarketingAirlineCode": "LH",
                            "MarketingAirlineName": "Lufthansa German Airlines",
                            "OperatingAirlineCode": "LH",
                            "OperatingAirlineName": "Lufthansa German Airlines",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-26T10:00:00",
                            "DepartureAirportCode": "FRA",
                            "DepartureAirportName": "Frankfurt Airport",
                            "DepartureAirportFullName": "Frankfurt Airport (FRA)",
                            "ArrivalDate": "2024-01-26T10:45:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "1h:45m",
                            "HasStopOver": true,
                            "StopOverDuartion": "3h:00m",
                            "TotalDuration": "4h:45m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "1",
                            "BaggageUnit": "PC",
                            "BookingCode": "V",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "V",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 2557,
            "TotalFare": 121487,
            "OriginalTotalFare": 121487,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 2557,
                    "TotalFare": 121487,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 121487
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 8,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 33,
                "GdsRecommendationID": 33
            },
            "IsLocal": false,
            "TotalFlightDuration": "13h:50m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "ET",
                    "OperatingAirlineName": "Ethiopia Airline",
                    "MarketingAirlineCode": "ET",
                    "MarketingAirlineName": "Ethiopia Airline",
                    "Duration": "15h:35m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T18:00:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-26T06:35:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "319",
                            "Aircraft": "BOEING 777-300ER",
                            "MarketingAirlineCode": "ET",
                            "MarketingAirlineName": "Ethiopia Airline",
                            "OperatingAirlineCode": "ET",
                            "OperatingAirlineName": "Ethiopia Airline",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T18:00:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T20:00:00",
                            "ArrivalAirportCode": "ADD",
                            "ArrivalAirportName": "Bole International Airport",
                            "ArrivalAirportFullName": "Bole International Airport (ADD)",
                            "FlightDuration": "2h:00m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "2h:00m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "K",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "K",
                                    "Quantity": "3",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "700",
                            "Aircraft": "AIRBUS INDUSTRIE A350",
                            "MarketingAirlineCode": "ET",
                            "MarketingAirlineName": "Ethiopia Airline",
                            "OperatingAirlineCode": "ET",
                            "OperatingAirlineName": "Ethiopia Airline",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-26T01:05:00",
                            "DepartureAirportCode": "ADD",
                            "DepartureAirportName": "Bole International Airport",
                            "DepartureAirportFullName": "Bole International Airport (ADD)",
                            "ArrivalDate": "2024-01-26T06:35:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "8h:30m",
                            "HasStopOver": true,
                            "StopOverDuartion": "5h:05m",
                            "TotalDuration": "13h:35m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "K",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "K",
                                    "Quantity": "3",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 2568,
            "TotalFare": 121973,
            "OriginalTotalFare": 121973,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 2568,
                    "TotalFare": 121973,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 121973
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 9,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 88,
                "GdsRecommendationID": 88
            },
            "IsLocal": false,
            "TotalFlightDuration": "15h:35m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "KQ",
                    "OperatingAirlineName": "Kenya Airways",
                    "MarketingAirlineCode": "KQ",
                    "MarketingAirlineName": "Kenya Airways",
                    "Duration": "8h:55m",
                    "StopOvers": 0,
                    "DepartureDate": "2024-01-25T01:55:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-25T07:50:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "KQ-SEG2",
                            "Aircraft": null,
                            "MarketingAirlineCode": "KQ",
                            "MarketingAirlineName": "Kenya Airways",
                            "OperatingAirlineCode": "KQ",
                            "OperatingAirlineName": "Kenya Airways",
                            "ArrivalTerminalName": "4",
                            "DepartureTerminalName": "1A",
                            "DepartureDate": "2024-01-25T01:55:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T07:50:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "8h:55m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "8h:55m",
                            "FlightClass": "Economy",
                            "Baggages": "24",
                            "BaggageUnit": "kg",
                            "BookingCode": "Y",
                            "AvailablePassengerSeats": []
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 15,
            "GDSId": 10,
            "Currency": "KES",
            "TotalServiceCharge": 2959,
            "TotalFare": 140564,
            "OriginalTotalFare": 140564,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 2959,
                    "TotalFare": 140564,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 140564
                }
            ],
            "Properties": {
                "CombinationID": 1,
                "RecommendationID": 14,
                "OWNER": "KQ",
                "OFFER_ID": "SLMP-5562196546481783647-1",
                "FLIGHT_KEY": "KQ-FLT1",
                "PRICE_CLASS_REFERENCE": "KQ-ECOSTDWW",
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "43538db3d2f540ccbf9a8d1b673679fa",
                "GdsCombinationID": 10,
                "GdsRecommendationID": 9
            },
            "IsLocal": false,
            "TotalFlightDuration": "8h:55m"
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "KQ",
                    "OperatingAirlineName": "Kenya Airways",
                    "MarketingAirlineCode": "KQ",
                    "MarketingAirlineName": "Kenya Airways",
                    "Duration": "8h:55m",
                    "StopOvers": 0,
                    "DepartureDate": "2024-01-25T09:35:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-25T15:30:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "KQ-SEG3",
                            "Aircraft": null,
                            "MarketingAirlineCode": "KQ",
                            "MarketingAirlineName": "Kenya Airways",
                            "OperatingAirlineCode": "KQ",
                            "OperatingAirlineName": "Kenya Airways",
                            "ArrivalTerminalName": "4",
                            "DepartureTerminalName": "1A",
                            "DepartureDate": "2024-01-25T09:35:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T15:30:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "8h:55m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "8h:55m",
                            "FlightClass": "Economy",
                            "Baggages": "24",
                            "BaggageUnit": "kg",
                            "BookingCode": "Y",
                            "AvailablePassengerSeats": []
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 15,
            "GDSId": 10,
            "Currency": "KES",
            "TotalServiceCharge": 2959,
            "TotalFare": 140564,
            "OriginalTotalFare": 140564,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 2959,
                    "TotalFare": 140564,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 140564
                }
            ],
            "Properties": {
                "CombinationID": 1,
                "RecommendationID": 13,
                "OWNER": "KQ",
                "OFFER_ID": "SLMP-5562196546481783647-2",
                "FLIGHT_KEY": "KQ-FLT2",
                "PRICE_CLASS_REFERENCE": "KQ-ECOSTDWW",
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "43538db3d2f540ccbf9a8d1b673679fa",
                "GdsCombinationID": 8,
                "GdsRecommendationID": 8
            },
            "IsLocal": false,
            "TotalFlightDuration": "8h:55m"
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "KQ",
                    "OperatingAirlineName": "Kenya Airways",
                    "MarketingAirlineCode": "KQ",
                    "MarketingAirlineName": "Kenya Airways",
                    "Duration": "8h:55m",
                    "StopOvers": 0,
                    "DepartureDate": "2024-01-25T01:55:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-25T07:50:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "102",
                            "Aircraft": "BOEING 787-8",
                            "MarketingAirlineCode": "KQ",
                            "MarketingAirlineName": "Kenya Airways",
                            "OperatingAirlineCode": "KQ",
                            "OperatingAirlineName": "Kenya Airways",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T01:55:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T07:50:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "8h:55m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "8h:55m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "L",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "L",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 3044,
            "TotalFare": 144614,
            "OriginalTotalFare": 144614,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 3044,
                    "TotalFare": 144614,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 144614
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 11,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 90,
                "GdsRecommendationID": 90
            },
            "IsLocal": false,
            "TotalFlightDuration": "8h:55m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "KQ",
                    "OperatingAirlineName": "Kenya Airways",
                    "MarketingAirlineCode": "KQ",
                    "MarketingAirlineName": "Kenya Airways",
                    "Duration": "8h:55m",
                    "StopOvers": 0,
                    "DepartureDate": "2024-01-25T09:35:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-25T15:30:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "100",
                            "Aircraft": "BOEING 787-8",
                            "MarketingAirlineCode": "KQ",
                            "MarketingAirlineName": "Kenya Airways",
                            "OperatingAirlineCode": "KQ",
                            "OperatingAirlineName": "Kenya Airways",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T09:35:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T15:30:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "8h:55m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "8h:55m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "L",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "L",
                                    "Quantity": "9",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 3044,
            "TotalFare": 144614,
            "OriginalTotalFare": 144614,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 3044,
                    "TotalFare": 144614,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 144614
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 10,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 91,
                "GdsRecommendationID": 91
            },
            "IsLocal": false,
            "TotalFlightDuration": "8h:55m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "ET",
                    "OperatingAirlineName": "Ethiopia Airline",
                    "MarketingAirlineCode": "ET",
                    "MarketingAirlineName": "Ethiopia Airline",
                    "Duration": "28h:35m",
                    "StopOvers": 1,
                    "DepartureDate": "2024-01-25T05:00:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-26T06:35:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "309",
                            "Aircraft": "BOEING 737-800",
                            "MarketingAirlineCode": "ET",
                            "MarketingAirlineName": "Ethiopia Airline",
                            "OperatingAirlineCode": "ET",
                            "OperatingAirlineName": "Ethiopia Airline",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-25T05:00:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T07:15:00",
                            "ArrivalAirportCode": "ADD",
                            "ArrivalAirportName": "Bole International Airport",
                            "ArrivalAirportFullName": "Bole International Airport (ADD)",
                            "FlightDuration": "2h:15m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "2h:15m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "S",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "S",
                                    "Quantity": "1",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        },
                        {
                            "FlightNumber": "700",
                            "Aircraft": "AIRBUS INDUSTRIE A350",
                            "MarketingAirlineCode": "ET",
                            "MarketingAirlineName": "Ethiopia Airline",
                            "OperatingAirlineCode": "ET",
                            "OperatingAirlineName": "Ethiopia Airline",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-26T01:05:00",
                            "DepartureAirportCode": "ADD",
                            "DepartureAirportName": "Bole International Airport",
                            "DepartureAirportFullName": "Bole International Airport (ADD)",
                            "ArrivalDate": "2024-01-26T06:35:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "8h:30m",
                            "HasStopOver": true,
                            "StopOverDuartion": "17h:50m",
                            "TotalDuration": "26h:20m",
                            "FlightClass": "ECONOMY",
                            "Baggages": "2",
                            "BaggageUnit": "PC",
                            "BookingCode": "S",
                            "AvailablePassengerSeats": [
                                {
                                    "PassengerType": "ADT",
                                    "PassengerClassCode": "S",
                                    "Quantity": "1",
                                    "FareBasis": null,
                                    "FareType": null
                                }
                            ]
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 8,
            "GDSId": 6,
            "Currency": "KES",
            "TotalServiceCharge": 4157,
            "TotalFare": 197472,
            "OriginalTotalFare": 197472,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 4157,
                    "TotalFare": 197472,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 197472
                }
            ],
            "Properties": {
                "CombinationID": 0,
                "RecommendationID": 12,
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "d8eeda5999044b008c75b256278d434e",
                "GdsCombinationID": 95,
                "GdsRecommendationID": 95
            },
            "IsLocal": false,
            "TotalFlightDuration": "28h:35m",
            "FlightRouteIndex": 0
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "KQ",
                    "OperatingAirlineName": "Kenya Airways",
                    "MarketingAirlineCode": "KQ",
                    "MarketingAirlineName": "Kenya Airways",
                    "Duration": "15h:00m",
                    "StopOvers": 0,
                    "DepartureDate": "2024-01-25T06:00:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-26T10:30:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "KQ-SEG14",
                            "Aircraft": "788",
                            "MarketingAirlineCode": "KQ",
                            "MarketingAirlineName": "Kenya Airways",
                            "OperatingAirlineCode": "KQ",
                            "OperatingAirlineName": "Kenya Airways",
                            "ArrivalTerminalName": "2E",
                            "DepartureTerminalName": "1A",
                            "DepartureDate": "2024-01-25T06:00:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T13:00:00",
                            "ArrivalAirportCode": "CDG",
                            "ArrivalAirportName": "Charles de Gaulle Airport (Roissy Airport)",
                            "ArrivalAirportFullName": "Charles de Gaulle Airport (Roissy Airport) (CDG)",
                            "FlightDuration": "7h:30m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "7h:30m",
                            "FlightClass": "Economy",
                            "Baggages": "24",
                            "BaggageUnit": "kg",
                            "BookingCode": "Y",
                            "AvailablePassengerSeats": []
                        },
                        {
                            "FlightNumber": "KQ-SEG15",
                            "Aircraft": null,
                            "MarketingAirlineCode": "KQ",
                            "MarketingAirlineName": "Kenya Airways",
                            "OperatingAirlineCode": "AF",
                            "OperatingAirlineName": "Air France",
                            "ArrivalTerminalName": "4",
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-26T10:00:00",
                            "DepartureAirportCode": "CDG",
                            "DepartureAirportName": "Charles de Gaulle Airport (Roissy Airport)",
                            "DepartureAirportFullName": "Charles de Gaulle Airport (Roissy Airport) (CDG)",
                            "ArrivalDate": "2024-01-26T10:30:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "7h:30m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "7h:30m",
                            "FlightClass": "Economy",
                            "Baggages": "24",
                            "BaggageUnit": "kg",
                            "BookingCode": "Y",
                            "AvailablePassengerSeats": []
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 15,
            "GDSId": 10,
            "Currency": "KES",
            "TotalServiceCharge": 4986,
            "TotalFare": 236861,
            "OriginalTotalFare": 236861,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 4986,
                    "TotalFare": 236861,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 236861
                }
            ],
            "Properties": {
                "CombinationID": 1,
                "RecommendationID": 15,
                "OWNER": "KQ",
                "OFFER_ID": "SLMP-5562196546481783647-6",
                "FLIGHT_KEY": "KQ-FLT4",
                "PRICE_CLASS_REFERENCE": "KQ-ECOFLEXWW",
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "43538db3d2f540ccbf9a8d1b673679fa",
                "GdsCombinationID": 6,
                "GdsRecommendationID": 6
            },
            "IsLocal": false,
            "TotalFlightDuration": "15h:00m"
        },
        {
            "FlightDetails": [
                {
                    "OperatingAirlineCode": "KQ",
                    "OperatingAirlineName": "Kenya Airways",
                    "MarketingAirlineCode": "KQ",
                    "MarketingAirlineName": "Kenya Airways",
                    "Duration": "4h:40m",
                    "StopOvers": 0,
                    "DepartureDate": "2024-01-25T08:20:00",
                    "DepartureAirportCode": "NBO",
                    "DepartureAirportName": "Jomo Kenyatta International Airport",
                    "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                    "ArrivalDate": "2024-01-26T07:40:00",
                    "ArrivalAirportCode": "LHR",
                    "ArrivalAirportName": "London Heathrow Airport",
                    "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                    "FlightEntries": [
                        {
                            "FlightNumber": "KQ-SEG4",
                            "Aircraft": null,
                            "MarketingAirlineCode": "KQ",
                            "MarketingAirlineName": "Kenya Airways",
                            "OperatingAirlineCode": "KQ",
                            "OperatingAirlineName": "Kenya Airways",
                            "ArrivalTerminalName": null,
                            "DepartureTerminalName": "1A",
                            "DepartureDate": "2024-01-25T08:20:00",
                            "DepartureAirportCode": "NBO",
                            "DepartureAirportName": "Jomo Kenyatta International Airport",
                            "DepartureAirportFullName": "Jomo Kenyatta International Airport (NBO)",
                            "ArrivalDate": "2024-01-25T14:50:00",
                            "ArrivalAirportCode": "AMS",
                            "ArrivalAirportName": "Amsterdam Airport Schiphol",
                            "ArrivalAirportFullName": "Amsterdam Airport Schiphol (AMS)",
                            "FlightDuration": "2h:20m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "2h:20m",
                            "FlightClass": "Economy",
                            "Baggages": "24",
                            "BaggageUnit": "kg",
                            "BookingCode": "Y",
                            "AvailablePassengerSeats": []
                        },
                        {
                            "FlightNumber": "KQ-SEG9",
                            "Aircraft": null,
                            "MarketingAirlineCode": "KQ",
                            "MarketingAirlineName": "Kenya Airways",
                            "OperatingAirlineCode": "KL",
                            "OperatingAirlineName": "KLM",
                            "ArrivalTerminalName": "4",
                            "DepartureTerminalName": null,
                            "DepartureDate": "2024-01-26T07:20:00",
                            "DepartureAirportCode": "AMS",
                            "DepartureAirportName": "Amsterdam Airport Schiphol",
                            "DepartureAirportFullName": "Amsterdam Airport Schiphol (AMS)",
                            "ArrivalDate": "2024-01-26T07:40:00",
                            "ArrivalAirportCode": "LHR",
                            "ArrivalAirportName": "London Heathrow Airport",
                            "ArrivalAirportFullName": "London Heathrow Airport (LHR)",
                            "FlightDuration": "2h:20m",
                            "HasStopOver": false,
                            "StopOverDuartion": "0h:00m",
                            "TotalDuration": "2h:20m",
                            "FlightClass": "Economy",
                            "Baggages": "24",
                            "BaggageUnit": "kg",
                            "BookingCode": "Y",
                            "AvailablePassengerSeats": []
                        }
                    ],
                    "FlightRules": []
                }
            ],
            "AgentId": 15,
            "GDSId": 10,
            "Currency": "KES",
            "TotalServiceCharge": 5995,
            "TotalFare": 284825,
            "OriginalTotalFare": 284825,
            "ExchangeRate": null,
            "TicketPurchaseCurrency": null,
            "PassengerFares": [
                {
                    "PassengerType": "ADT",
                    "Age": null,
                    "Quantity": 1,
                    "ServiceCharge": 5995,
                    "TotalFare": 284825,
                    "TicketRules": [],
                    "OriginalGdsBaseFare": 0,
                    "OriginalGdsTotalFare": 0,
                    "OriginalAgentMarkupFare": 0,
                    "OriginalTotalFare": 284825
                }
            ],
            "Properties": {
                "CombinationID": 1,
                "RecommendationID": 16,
                "OWNER": "KQ",
                "OFFER_ID": "SLMP-5562196546481783647-11",
                "FLIGHT_KEY": "KQ-FLT9",
                "PRICE_CLASS_REFERENCE": "KQ-ECOFLEXWW",
                "EnsureAgentUnicityForRoutes": false,
                "TransportServiceType": 2,
                "TripsSessionId": "6c0869b17e7f4489a999b921e3521c1b",
                "GdsSessionId": "43538db3d2f540ccbf9a8d1b673679fa",
                "GdsCombinationID": 1,
                "GdsRecommendationID": 1
            },
            "IsLocal": false,
            "TotalFlightDuration": "4h:40m"
        }
    ],
    "Errors": null
}






